import { Button, Form, Input, message, Modal } from "antd";
import React from "react";
import { UPDATE_TASK_STATUS } from "../../../Graphql/mutations";
import "./CancelTaskModal.less";
import { useMutation } from "@apollo/react-hooks";
import { useForm } from "antd/lib/form/Form";

const { TextArea } = Input;

export const CancelTaskModal = ({ visible, onCancel, taskId }) => {
  
  const [form] = Form.useForm()
  form.resetFields()
  const [UPDATE_TASK_STATUS_MUTATION, { loading: isUpdatingTask }] =
    useMutation(UPDATE_TASK_STATUS);

  const onFinish = async (value) => {
    try {
      const isUpdateSuccessful = await UPDATE_TASK_STATUS_MUTATION({
        variables: {
          user_id: localStorage.getItem("user_id"),
          task_id: taskId,
          task_status: "incomplete",
          note: value.cancel_task,
          task_status_updated_at: new Date().toISOString(),
        },
      });
      if (!isUpdateSuccessful.errors) {
        message.success("Task Updated Successfully");
        onCancel();
      } else {
        message.error("Something went wrong...");
      }
    } catch (error) {}
  };

  return (
    <Modal
      centered
      visible
      footer={null}
      // width={1000}
      wrapClassName="cancelTaskModalPop"
      visible={visible}
      onCancel={onCancel}
    >
      <Form name="basic" form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          label="Why are you not able to complete this task?"
          name="cancel_task"
          rules={[
            {
              required: true,
              message: "Please enter reason!",
              whitespace: true,
            },
          ]}
        >
          <TextArea
            placeholder="Reason for not completing task."
            rows={4}
            className="w-100"
          />
        </Form.Item>

        <Form.Item className="mb-0 text-center">
          <Button
            loading={isUpdatingTask}
            type="primary"
            shape="round"
            size="large"
            className=""
            htmlType="submit"
          >
            {isUpdatingTask ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
